module.exports = __webpack_public_path__ + "static/media/11_plantilla_menu_comida_21.e76c2522.png";